"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMarkBasedComparisonSpec = void 0;
/**
 * @param message The user facing string to describe this spec. Unused outside
 * the adjust and compare screen in phoenix.
 * @param numberOfMarks The number of marks to look back. Defaults to 1 if unset.
 */
var makeMarkBasedComparisonSpec = function (message, numberOfMarks) {
    return {
        type: 'MARK_BASED_COMPARISON',
        numberOfMarks: numberOfMarks !== null && numberOfMarks !== void 0 ? numberOfMarks : 1,
        message: message,
    };
};
exports.makeMarkBasedComparisonSpec = makeMarkBasedComparisonSpec;
//# sourceMappingURL=MarkBasedComparisonSpec.js.map